export function arraysAreEqual<T>(
	array1: readonly T[],
	array2: readonly T[] | undefined,
): boolean {
	if (array2 === undefined) {
		return false
	}
	return (
		array1.length === array2.length &&
		array1.every((value, index) => value === array2[index])
	)
}
